import curveLinear from "./linear.js";
export var curveRadialLinear = curveRadial(curveLinear);
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function () {
        this._curve.areaStart();
    },
    areaEnd: function () {
        this._curve.areaEnd();
    },
    lineStart: function () {
        this._curve.lineStart();
    },
    lineEnd: function () {
        this._curve.lineEnd();
    },
    point: function (a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
export default function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}
